'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { IS_SSR } from '@/ots-constants';
import { REVIEW_ANCHOR } from '@/page-components/resort/constants';

export const useDefaultScrollToTop = (offsetLeft?: number | null, offsetTop?: number | null) => {
  const pathname = usePathname() ?? '';
  // usePathname() drops fragments. Re-read window.location.hash on each
  // pathname change to get the same "skip scroll on review anchor" behavior.
  const hash = !IS_SSR && typeof window !== 'undefined' ? window.location.hash.slice(1) : '';
  const scrollValues = { top: offsetTop ?? 0, left: offsetLeft ?? 0 };

  useEffect(() => {
    if (!IS_SSR && hash !== REVIEW_ANCHOR) {
      window.scroll({
        top: scrollValues.top,
        left: scrollValues.left,
      });
    }
  }, [hash, pathname]);
};
